import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortDashboardComponent } from './port-dashboard.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule } from '@angular/forms';
import { NgChartsModule } from 'ng2-charts';
import { ChartModule } from 'angular-highcharts';
import { PortDashboardRoutingModule } from './port-dashboard-routing.module';
import { PcFleetModule } from "./pc-fleet/pc-fleet.module";
import { ChartZoomModalComponent } from './chart-zoom-modal.component';
import { PcMultiSelectFilterModule } from 'src/app/shared/components/pc-multi-select-filter/pc-multi-select-filter.module';



@NgModule({
  declarations: [
    PortDashboardComponent,
    ChartZoomModalComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    NgChartsModule,
    ChartModule,
    PcMultiSelectFilterModule,
    PortDashboardRoutingModule,
    PcFleetModule
],
  exports:[
    PortDashboardComponent
  ]
})
export class PortDashboardModule { }
